export default function Button(props) {
  return (
    <div>
      <button className="album-button">{props.text}</button>
    </div>
  );
}